import { connect } from 'react-redux';
import Rsee from '../../app/admin/Rsee';

const mapStateToProps = (state) => ({
  parsedProject: state.projects.parsedProject,
  currentProject: state.projects.currentProject,
});

export default connect(mapStateToProps)(Rsee);
